import React from 'react';
import { FaGithubSquare } from 'react-icons/fa'
import {FiExternalLink} from 'react-icons/fi'

const projet = [
    {
      id: 1,
      title: 'REACT-REDUX-JSON',
      img: './imagesProjet/react-redux.jpg',
      desc: `Application react redux connectée à une api de cocktails. Illustraction de l'utilisation de format redux et de json `,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/recettes',
        link2: 'https://application-recettes-react-redux.netlify.app'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: "CSS"
      },
    },
    {
      id: 2,
      title: 'REACT - AJX - JSON API RESTAURANT',
      img: './imagesProjet/image_api_cocktail.png',
      desc: `vaporware iPhone mumblecore selvage raw denim slow-carb leggings gochujang helvetica man braid jianbing. Marfa thundercats `,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/react_api_restaurant.git',
        link2: 'https://react-api-restaurant.netlify.app'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: "CSS"
      },
    },
    {
      id: 3,
      title: 'SITE E-COMMERCE PHP',
      img: './imagesProjet/site_e-commerce.png',
      desc: `Le site e-commerce ou commerce électronique correspond à la vente en ligne de biens ou de services au travers de sites web marchands.`,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/Mobile_shop',
        link2: './images/site_e-commerce-php.pdf'
      },
      langage:{
        langage1: "PHP", 
        langage2: "HTML - JAVASCRIP",
        langage3: "CSS"
      },
    },
    {
      id: 4,
      title: 'SITE STATIQUE HTML BOOSTRAP',
      img: './imagesProjet/bootstrap.jpg',
      desc: `Shabby chic keffiyeh neutra snackwave pork belly shoreditch. Prism austin mlkshk truffaut, `,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/site-hubs',
        link2: 'https://site-statique-hubs.netlify.app/'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: ""
      },
    },
    {
      id: 5,
      title: 'VEILLE TECHNOLOGIQUE',
      img: './imagesProjet/photo-surveillance-température.jpg',
      desc: `La veille technologique ou veille scientifique et technique consiste à s'informer de façon systématique sur les techniques les plus récentes`,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/Veille_technologique',
        link2:'https://veilletechnologique.netlify.app/'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: "CSS"
      },
    },
    {
      id: 6,
      title: 'REACT-NATIVE',
      img: './imagesProjet/react-native.jpg',
      desc: `franzen vegan pabst bicycle rights kickstarter pinterest meditation farm-to-table 90's pop-up `,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://www.twitter.com',
        link2: 'https://www.twitter.com'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: "CSS"
      },
    },
    
    
    
  ];

  export const projetBTS2 = [
    {
      id: 1,
      title: 'GSB1 - Gestion des fiches de frais',
      img: './imagesProjet/projet_gsb1_1.png',
      desc: `Septembre 2019 - Octobre 2019 Projet
      Cette réalisation avait pour but de mettre en pratique la nouvelle méthode MVC vue en cours dans une application PHP, HTML, CSS, SQL de gestion de suivi et paiement des fiches de frais des visiteurs médicaux de GSB.
      L'application devait gérer une interface pour deux types d'utilisateurs : visiteurs et comptables.
      Cette application a été réalisée dans les temps sans difficulté majeure mais avec un binôme avec deux rythmes très différents et une implication dans le projet déséquilibrée. `,
      link:'https://github.com/JustDevF/GSB3_Gestion_Conferences',
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/projetsbg1',
        link2: 'https://github.com/JustDevF/projetsbg1'
      },
      langage:{
        langage1: "PHP", 
        langage2: "MySQL",
      },
    },
    {
      id: 2,
      title: 'GSB2 - Gestion des locations de matériels',
      img: './imagesProjet/projet_gsb2_1.PNG',
      desc: `Décembre 2019
      Projet réalisé en binôme.
      Cette réalisation avait pour but de mettre en pratique la méthode MVC appliquée dans le dernier projet mais cette fois-ci dans le langage JAVA + SQL, dans une application de gestion des locations de matériels pour les visiteurs médicaux de GSB.
      L'application devait gérer une interface pour trois types d'utilisateurs : responsables, visiteurs et directeur.
      Cette application a été réalisée dans les temps sans difficulté majeure mais avec une charge de travail légèrement déséquilibrée et des résulats de qualité différente (dysfonctionnements). `,
      link:'https://github.com/JustDevF/GSB-3_gestion_materiel_medical',
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/GSB-3_gestion_materiel_medical',
        link2: 'https://github.com/JustDevF/GSB-3_gestion_materiel_medical'
      },
      langage:{
        langage1: "JAVA", 
        langage2: "MySQL",
      },
    },
    {
      id: 3,
      title: 'GSB3 - Gestion des conférences',
      img: './imagesProjet/projet_gsb3_1.PNG',
      desc: `Février 2020
      Projet réalisé durant la deuxième année de BTS, en début d'année 2020. Il a été réalisé seule.
      Cette réalisation avait pour but de se familiariser avec le FrameWork CodeIgniter vu en cours dans une application PHP, HTML, CSS, SQL de gestion des conférences de GSB.
      L'application devait gérer une interface pour deux types d'utilisateurs : visiteurs et responsables.
      Cette application a été réalisée largement en avance sans difficulté majeure hormis une prise en main de l'outil progressive.`,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/GSB3_Gestion_Conferences',
        link2: 'https://github.com/JustDevF/GSB3_Gestion_Conferences'
      },
      langage:{
        langage1: "PHP", 
        langage2: "MySQL",
        langage3: "CodeIgniter"
      },
    }
    
  ];

  export const projetBTS1 = [
    {
      id: 1,
      title: 'Site web marchand',
      img: './imagesProjet/projet_site_marchand_1.PNG',
      desc: `Février 2019 - Septembre 2019
      Projet réalisé durant la première année de BTS, durant le deuxième semestre. Il a été initié en groupe de 3 puis le groupe s'est dissocié pour la partie dynamique du site afin de travailler seule.
      Cette réalisation avait pour but de mettre en pratique les notions de dynamisme apprises en PHP dans la conception d'un site marchand dynamique, à rajouter avec toutes les notions vues précédemment en HTML, CSS, SQL et JavaScript avec la classe PDO dans uns second temps.`,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/Mobile_shop',
        link2: 'https://github.com/JustDevF/Mobile_shop'
      },
      langage:{
        langage1: "PHP", 
        langage2: "MySQL",
        langage3: "CSS"
      },
    },
    {
      id: 2,
      title: 'Veille_technologique',
      img: './imagesProjet/projet_veille_1.PNG',
      desc: `Mars 2019
      Cette réalisation avait pour but de mettre en pratique les notions de Java avec l'héritage et l'IHM (Interface Homme/Machine) vues en cours dans une application de gestion.
Cette application a été réalisée dans les temps sans difficulté majeure. La partie avec héritage a été réalisée dans un second temps.`,
      icons : {
        icon1:<FaGithubSquare />,
        icon2: <FiExternalLink />
      },
      links: {
        link1:'https://github.com/JustDevF/Veille_technologique',
        link2:'https://veilletechnologique.netlify.app/'
      },
      langage:{
        langage1: "JAVASCRIP", 
        langage2: "HTML",
        langage3: "CSS"
      },
    }
    
  ];

  export default projet;